export default "__VITE_ASSET__HZV9rx0e__"